export default __webpack_public_path__ + "static/media/apiurl.91915118.png";